<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';
	import Carousel from '$lib/carousel.svelte';
	import type { EmblaCarouselType } from 'embla-carousel';
	import ArrowLeft from '$lib/icons/arrowLeft.svelte';
	import ArrowRight from '$lib/icons/arrowRight.svelte';
	import Button from '$lib/buttons/v3/button.svelte';
	import { fly } from 'svelte/transition';
	import SimpleGalleryIndicator from '$lib/simpleGalleryIndicator.svelte';
	import { device } from '$lib/state/device.svelte';
	interface Props {
		content: ISbStoryData<{
			assets_mobile: ISbStoryData[];
			assets_desktop: ISbStoryData[];
		}>['content'];
	}

	let { content }: Props = $props();

	const assets = $derived(device.data.isDesktop ? content.assets_desktop : content.assets_mobile);

	let embla = $state<EmblaCarouselType>();
	let currentIndex = $state(0);

	function next() {
		if (embla) {
			if (currentIndex === assets.length - 1) {
				clickedThrough = true;
			}

			embla.canScrollNext() ? embla.scrollNext() : embla.scrollTo(0);
		}
	}

	function previous() {
		if (embla) {
			embla.canScrollPrev() ? embla.scrollPrev() : embla.scrollTo(assets.length - 1);
		}
	}

	let clickedThrough = $state(false);
</script>

<section class="relative" use:editable={content}>
	<Carousel
		bind:embla
		bind:currentIndex
		draggable={!device.data.isDesktop}
		autoplay={false}
		align="center"
		loop
		class="flex max-lg:aspect-2/3 lg:h-[calc(100svh-var(--header-height))]"
	>
		{#each assets as item}
			<div class="h-full flex-none basis-full">
				<Blok content={item} />
			</div>
		{/each}
	</Carousel>

	<div class="absolute inset-x-0 bottom-5">
		<SimpleGalleryIndicator
			active={currentIndex}
			count={device.data.isDesktop ? content.assets_desktop.length : content.assets_mobile.length}
			activeColor="white"
			onchange={(idx) => embla?.scrollTo(idx)}
		/>
	</div>

	{#if currentIndex !== 0 || clickedThrough}
		<button
			aria-label="previous"
			onclick={previous}
			class="absolute top-0 h-full w-[30%] max-lg:hidden"
		></button>
	{/if}
	<button
		aria-label="next"
		onclick={next}
		class="absolute right-0 top-0 h-full w-[30%] max-lg:hidden"
	></button>

	{#if assets.length > 2}
		{#if currentIndex !== 0 || clickedThrough}
			<div class="absolute left-6 top-1/2 -translate-y-1/2" transition:fly={{ x: '-100%' }}>
				<Button onclick={previous} class="btn-white max-lg:hidden">
					<ArrowLeft />
				</Button>
			</div>
		{/if}
		<div class="absolute right-6 top-1/2 -translate-y-1/2">
			<Button onclick={next} class="btn-white max-lg:hidden">
				<ArrowRight />
			</Button>
		</div>
	{/if}
</section>
